<template>
  <div class="page-imports">
    <h1 class="title">Data Import Center</h1>
    <p class="subtitle">
      Upload your data files (CSV or Excel) and download the import report.
    </p>

    <div class="columns is-multiline mt-5">
      <!-- Third Parties -->
      <div class="column is-6">
        <FileImport
          endpoint="/third-parties/import/"
          label="Third Parties"
          filename="thirdparty_import_report.txt"
        />
      </div>

      <!-- Items -->
      <div class="column is-6">
        <FileImport
          endpoint="/items/import/"
          label="Items"
          filename="item_import_report.txt"
        />
      </div>
      <!-- Future imports can be added here -->
    </div>
  </div>
</template>

<script>
import FileImport from '@/components/FileImport.vue';

export default {
  name: 'DashboardImport',
  components: { FileImport },
};
</script>

<style scoped>
.page-imports {
  max-width: 1100px;
  margin: 0 auto;
  padding: 2rem;
}
</style>
